import React from 'react'; // eslint-disable-line no-unused-vars
import styled from 'react-emotion';

const Button = styled('span')`
  cursor: pointer;
  color: ${props => props.active ? 'orange' : '#ccc'};
  &:hover{
    color: orange;
  }
`;

export default Button;
